import { render, staticRenderFns } from "./repayment_dialog.vue?vue&type=template&id=2036ec76&"
import script from "./repayment_dialog.vue?vue&type=script&lang=js&"
export * from "./repayment_dialog.vue?vue&type=script&lang=js&"
import style0 from "./repayment_dialog.vue?vue&type=style&index=0&id=2036ec76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports